import TeamsPage from './TeamsPage';

export default TeamsPage;
